<div class="content-wrapper">
    <div class="content-wrapper">
        <div class="content-body">

            <app-content-header [contentHeader]="contentHeader"></app-content-header>

            <div class="card">

                <section id="ngx-datatable-inline-editing">
                    <div class="row">
                        <div class="col-12">
                            <!-- <button class="btn btn-primary float-right mr-1 mt-1"
                                routerLink="/cliente-fechamento/cadastro" rippleEffect>
                                <i data-feather="plus" class="mr-0 mr-sm-1"></i><span
                                    class="d-none d-sm-inline-block">Nova <b>Fatura</b></span>
                            </button> -->
                        </div>
                    </div>
                    <hr>

                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="d-flex justify-content-between align-items-center m-1">
                                <label class="d-flex align-items-center">Mostrar
                                    <select class="form-control mx-25" [(ngModel)]="basicSelectedOption">
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </label>
                            </div>
                        </div>
                    </div>

                    <ng-template #customLoadingIndicator>
                        <div class="custom-loading-indicator">
                            <i class="fa fa-spinner fa-spin"></i>
                        </div>
                    </ng-template>

                    <!-- DATATABLE -->
                    <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
                        [reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
                        [loadingIndicator]="loadingPage" style="box-shadow: none" [rows]="rows" [scrollbarH]="true">

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Nome Fantasia</h4>
                                <input type="search" placeholder="Nome Fantasia" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'nome_cliente')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.nome_cliente}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Razão Social</h4>
                                <input type="search" placeholder="Razão Social" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'razao_social')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.razao_social}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>CPF/CNPJ</h4>
                                <input type="search" placeholder="BOLETO" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'pagamento')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.cpfCnpj}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>MÉTODO DE PAGAMENTO</h4>
                                <input type="search" placeholder="BOLETO" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'pagamento')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.pagamento}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [width]="20" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <div class="d-flex align-items-center" style="float: right">
                                    <div ngbDropdown container="body">
                                        <a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
                                            id="dropdownBrowserState" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                            <i data-feather="more-vertical"
                                                class="text-primary cursor-pointer mr-50"></i>
                                        </a>
                                        <div ngbDropdownMenu class="dropdown-menu-right"
                                            aria-labelledby="dropdownBrowserState">
                                            <a (click)="visualizaFatura(row.token)" ngbDropdownItem
                                                class="d-flex align-items-center"><i data-feather="file-text"
                                                    class="mr-50"></i> Visualizar fatura</a>
                                            <a (click)="copiarLinkFatura(row.token)" ngbDropdownItem
                                                class="d-flex align-items-center"><i data-feather="link"
                                                    class="mr-50"></i> Copiar link da Fatura</a>
                                            <!-- <a (click)="confirmDeleteAlert(row.id_sistema)" ngbDropdownItem
												class="d-flex align-items-center"><i data-feather="trash-2"
													class="mr-50"></i> Excluir</a> -->
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>
                </section>

            </div>
        </div>
    </div>